export default __webpack_public_path__ + "static/media/startup-btn.9cf67f3e.svg";